import { z } from 'zod';
import { HistoryEntrySchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema, } from './shared.js';
export const DocumentTypeSchema = z.enum([
    'quote_pdf',
    'msa_unsigned',
    'msa_signed',
    'work_order',
    'intake_response',
    'certificate',
    'signed_agreement',
    'invoice_pdf',
    'rep_uploaded',
    'customer_uploaded',
    'other',
]);
export const DocumentUploadedSourceSchema = z.enum([
    'manual_rep',
    'manual_customer_portal',
    'quote_autosave',
    'docusign_completed',
    'intake_form_submit',
    'system_generated',
    'invoice_sync',
]);
export const DocumentSchema = z.object({
    id: IDSchema,
    type: z.literal('document'),
    schemaVersion: SchemaVersionSchema,
    accountId: IDSchema,
    documentType: DocumentTypeSchema,
    filename: z.string(),
    sharepointDriveId: z.string(),
    sharepointItemId: z.string(),
    sharepointWebUrl: z.string().url(),
    sizeBytes: z.number().int().nonnegative(),
    contentType: z.string(),
    version: z.number().int().positive(),
    supersededByDocumentId: IDSchema.optional(),
    dealId: IDSchema.optional(),
    quoteId: z.string().optional(),
    submissionId: IDSchema.optional(),
    meetingId: IDSchema.optional(),
    invoiceId: IDSchema.optional(),
    uploadedBy: z.string(),
    uploadedAt: IsoTimestampSchema,
    uploadedSource: DocumentUploadedSourceSchema,
    // RIG-336 — uses the shared HistoryEntrySchema (payload omitted: this entity
    // intentionally does not record structured history payloads).
    history: z.array(HistoryEntrySchema.omit({ payload: true })).default([]),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
});
//# sourceMappingURL=document.js.map